import { render } from "./PantryValueDialog.vue?vue&type=template&id=cc707664&ts=true"
import script from "./PantryValueDialog.vue?vue&type=script&lang=ts"
export * from "./PantryValueDialog.vue?vue&type=script&lang=ts"

import "./PantryValueDialog.vue?vue&type=style&index=0&id=cc707664&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__